import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../services/common/api.service';
import { Jsonp } from '@angular/http';
@Injectable()

export class ThongTinDiemDoService {
  data: any = {};
  datanew: any = {};

  constructor(private router: Router, private api: ApiService) {

  }
  APIURL = "api/ExcuteOracle";
  // lấy danh sách công tơ của 1 điểm đo
  // getDsCongto(meterid) {
  //   var param = {
  //     "config": '{"namesql":"PKG_KHACHHANG.P_LAYDS_CONGTO"}',
  //     "para": '{"v_meterid":"' + meterid + '"}'
  //   };
  //   return this.api.Excute(this.APIURL, param);
  // }
  // timKiemDiemDo(keyword,sotrang,sodong) {
  //   var param = {
  //     "config": '{"namesql":"PKG_KHACHHANG.P_TIMKIEM_DIEMDO"}',
  //     "para": '{"v_keyword":"' + keyword + '","v_danhmucid":"0","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '"}'
  //   };
  //   return this.api.Excute(this.APIURL, param);
  // }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/thongtindiemdo.service.ts